// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"d9d64531","91":"31d6cfe0","631":"fde36d2d","800":"31d6cfe0"}[chunkId] + ".chunk.css";
};